<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Member/MemberList.html')">会员管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>会员列表</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="昵称">
				<el-input v-model="item.nick_name" placeholder="请输入昵称" size="small"></el-input>
			</el-form-item>
			<el-form-item label="手机号">
				<el-input v-model="item.mobile" placeholder="请输入手机号码" size="small"></el-input>
			</el-form-item>
			<el-form-item label="所属店铺">
				<el-select v-model="item.store_id" clearable placeholder="请选择" size="small">
					<el-option v-for="item in storeOptions" :key="item.value" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="时间">
				<el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="daterange"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
				<el-button type="success" @click="excelOut" size="medium">导出</el-button>
			</el-form-item>
		</el-form>
		<!--		数据是list 通过list展示-->
		<el-table :data="list" border>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.row.id}}
				</template>
			</el-table-column>

			<el-table-column label="头像">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.avatar" height="30" style="display:
                        flex;border-radius: 50%" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="nick_name" label="昵称"></el-table-column>
			<el-table-column prop="real_name" label="姓名"></el-table-column>
			<el-table-column prop="mobile" label="手机号码"></el-table-column>
			<el-table-column label="性别">
				<template slot-scope="scope">
					<div v-if="scope.row.sexy == 1">
						男
					</div>
					<div v-else>
						女
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="jifen" label="积分"></el-table-column>
			<el-table-column label="状态" align="center">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.is_enabled">
						激活
					</el-tag>
					<el-tag size="small" type="danger" v-else>
						冻结
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="storeName" label="所属店铺">
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.store">
						{{scope.row.store.name}}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="创建时间"></el-table-column>
			<el-table-column prop="last_modified_date" label="最后登录时间"></el-table-column>
			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/member/detail']">查看</el-button>
					<el-button size="mini" type="primary" @click="pay(scope.row.id)" v-auth="['admin/member/addJifen']">充值</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 充值 -->
		<el-dialog title="充值" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<el-form ref="form" label-width="80px">
				<el-form-item label="充值方式">
					<el-radio v-model="jifenType" label="1">增加</el-radio>
					<el-radio v-model="jifenType" label="2">减少</el-radio>
				</el-form-item>
				<span style="display: flex;align-items: center;">
					<span style="flex-shrink: 0;margin-right: 10px;">充值积分</span>
					<el-input v-model="jifen" placeholder="请输入积分数额" style="flex-grow: 1;" oninput="value=value.replace(/\D|^0/g,'')"></el-input>
				</span>
			</el-form>
			<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="sureSub">确 定</el-button>
				</span>
		</el-dialog>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				dialogVisible: false,
				// 查询
				item: {},
				jifen: '',
				jifenId: '',
				levelOptions: [],
				storeOptions: [],
				jifenType: '1'
			}
		},
		created() {
			this.item = {
				page: this.page,
				limit: this.pageSize
			}
			this.loadList()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			async loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				let res = ''
				// 所属店铺列表
				res = await this.axios.post('/admin/business.store/list', {
				})
				// 获取数据
				this.storeOptions = res.data.list

				res = await this.axios.post('/admin/member/list', this.item)
					.then(res => {
						// 获取数据
						this.list = res.data.list.data
						// 页数 page
						this.total = res.data.list.total
					})
				this.isLoad = !this.isLoad
			},
			// 导出
			excelOut() {
				if (this.isLoad) {
					return false
				}

				this.isLoad = !this.isLoad
				setTimeout(function () {
					this.isLoad = false
				}.bind(this), 100000);
				this.axios.post('/admin/member/export', this.item)
				.then(res => {
					this.isLoad = false
					if (res.code == 1) {
						import('@/vendor/Export2Excel.js').then(excel => {
							var expCellName = res.data.expCellName
							var tHeader = []
							var filterVal = []
							for (var i in expCellName) {
								tHeader.push(expCellName[i])
								filterVal.push(i)
							}
							const expTableData = res.data.expTableData
							const data = this.formatJson(filterVal, expTableData)
							var d = new Date()
							var year = d.getFullYear()
							var month = d.getMonth()
							var date = d.getDate()
							var hour = d.getHours()
							var minute = d.getMinutes()
							var second = d.getSeconds()
							month = month < 10 ? '0' + month : month
							date = date < 10 ? '0' + date : date
							hour = hour < 10 ? '0' + hour : hour
							minute = minute < 10 ? '0' + minute : minute
							second = second < 10 ? '0' + second : second
							excel.export_json_to_excel({
								header: tHeader,
								data,
								filename: '会员导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
								autoWidth: this.autoWidth,
								bookType: this.bookType
							})
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
							duration: 3 * 1000
						})
					}
				})
			},
			formatJson (filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => {
					return v[j]
				}))
			},
			pay(id) {
				this.dialogVisible = true
				this.jifenId = id
			},
			sureSub() {
				this.jifen = parseFloat(this.jifen)
				this.axios.post('/admin/member/addJifen', {
						id: this.jifenId,
						jifen: this.jifen,
						type: this.jifenType
					})
					.then(() => {
						this.jifen = ''
						this.$message.success({
							message: '充值成功'
						});
						this.loadList()
						this.dialogVisible = false
					})
					.catch(() => {
						this.jifen = ''
					})
			},
			handleClose(done) {
				this.dialogVisible = false
				this.jifen = ''
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Member/MemberListEdit.html',
					query: {
						id: id
					}
				});
			},
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},

			// 分页
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},


		}
	}
</script>
<style scoped>
	.el-form--inline .el-form-item {
		margin-bottom: 16px;
	}

	.search {
		margin-top: 16px;
	}
</style>
